import React from 'react';

/**
 * Template 5: TARA — Editorial Chic
 * Button variants: primary, secondary, editorial
 */
const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    type = 'button',
    disabled = false,
    className = ''
}) => {
    const base = 'inline-flex items-center justify-center gap-2 transition-all duration-300 tracking-[0.15em] uppercase';

    const variants = {
        primary: `${base} bg-[#2C2C2C] text-white hover:bg-[#1A1A1A] active:scale-[0.98] disabled:opacity-50`,
        secondary: `${base} bg-transparent border border-[#2C2C2C] text-[#2C2C2C] hover:bg-[#2C2C2C] hover:text-white active:scale-[0.98] disabled:opacity-50`,
        editorial: 'inline-flex items-center gap-2 underline underline-offset-4 decoration-[#2C2C2C] text-[#2C2C2C] hover:opacity-70 transition-opacity duration-300 tracking-[0.1em]',
    };

    const sizes = {
        sm: 'px-5 py-2.5 text-[10px] md:text-xs',
        md: 'px-6 py-3 md:px-8 md:py-3.5 text-[11px] md:text-xs',
        lg: 'px-8 py-3.5 md:px-10 md:py-4 text-xs md:text-sm',
    };

    const sizeClass = variant === 'editorial' ? 'text-sm md:text-base' : (sizes[size] || sizes.md);
    const widthClass = fullWidth ? 'w-full' : '';

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`${variants[variant] || variants.primary} ${sizeClass} ${widthClass} ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'} ${className}`}
            style={{ fontFamily: "'Outfit', sans-serif" }}
        >
            {children}
        </button>
    );
};

export default Button;
